import * as C from '../constants/documentTypes';

const GENERIC_STATE = {
  data: {},
  error: null,
  fetching: false,
  success: false,
};

function formatSubmittedDocResponseUtil(response) {
  const data = response.reduce((map, obj) => {
    map[obj.document_category_id] = obj;
    return map;
  }, {});
  return data;
}

export default function documentReducer(state = GENERIC_STATE, action) {
  switch (action.type) {
    case C.FETCH_SUBMITTED_DOC_LIST_INITIATED:
      return { ...state, fetching: true, fetched: false };
    case C.FETCH_SUBMITTED_DOC_LIST_SUCCESS: {
      const formattedResponse = formatSubmittedDocResponseUtil(action.payload.kyc_documents);
      return {
        ...state,
        data: formattedResponse,
        fetching: false,
        fetched: true,
      };
    }
    case C.UPLOAD_DOCUMENT_SUCCESS: {
      const { document_category_id: documentCategory } = action.payload.kyc_document;
      return {
        ...state,
        data: { ...state.data, [documentCategory]: action.payload.kyc_document },
      };
    }
    case C.REMOVE_DOCUMENT_SUCCESS: {
      const updateData = { ...state.data };
      delete updateData[action.payload.document_category_id];
      return { ...state, data: { ...updateData } };
    }
    case C.FETCH_SUBMITTED_DOC_LIST_FAILURE:
      return { ...state, fetching: false, error: action.payload };
    case C.REFER_BULK_INITIATED:
      return {...state, fetching: true, success: false, error: null,}
    case C.REFER_BULK_SUCCESS:
      return {
        ...state, fetching: false, success: true, data: {...action.payload }
      };
    case C.UPDATE_BULK_SUCCESS:
      return {
        ...state, fetching: false, success: true, data: {...action.payload }
      };
    case C.REFER_BULK_FAILED:
      return { ...state, fetching: false, error: action.payload };

    case C.REMOVE_BULK_SUCCESS: {
      const updateData = { ...state.data };
      delete updateData.bulk_referral;
      return { ...state, data: { ...updateData } };
    }
    default:
      return state;

    case C.UPLOAD_ICON_INITIATED:
      return { ...state, fetching: true, success: false };
    case C.UPLOAD_ICON_SUCCESS:
      return { ...state, fetching: false, success: true, data: {...action.payload } };
    case C.UPLOAD_ICON_FAILURE:
      return { ...state, fetching: false, success: false, error: action.payload};
    case C.REMOVE_ICON_SUCCESS:
      const updateData = { ...state.data }
      return { ...state, fetching: false, success: true, data: { ...updateData} };
  }
}
